<template>
    <transition name="slide-fade">
        <div
            class="notification-request"
            :class="{ denied: deniedMode }"
            @click="deniedMode ? enableNotifications : $_.noop"
        >
            <div class="notification-request-text" @click="enableNotifications">
                <i v-if="deniedMode">
                    {{ $t("message.deniedText") }}
                </i>
                <i v-else>
                    {{ $t("message.notificationText") }}
                </i>

                <button class="notification-request-button" v-if="!deniedMode">
                    {{ $t("message.enableNotification") }}
                </button>
                <button class="notification-request-button" v-else @click="enableNotifications">
                    {{ $t("message.showNotificationGuide") }}
                </button>
            </div>
            <div class="notification-request-close" v-if="deniedMode">
                <button class="notification-request-close-button" @click="closeNotification">
                    <md-icon class="notification-request-icon" style="color: #ffffff">close</md-icon>
                </button>
            </div>
            <a-modal
                :visible="showNotificationEnableGuidModal"
                @cancel="() => (showNotificationEnableGuidModal = false)"
                @ok="() => (showNotificationEnableGuidModal = false)"
                centered
                :title="$t('message.howToEnableNotification')"
                :cancelText="$t('message.notificationCancel')"
                :okText="$t('message.notificationOK')"
            >
                <div>
                    <p>
                        <a-icon type="lock" />
                        {{ $t("message.howToEnableNotificationInstruction1") }}
                    </p>
                    <p>
                        <a-icon type="notification" />
                        {{ $t("message.howToEnableNotificationInstruction2") }}
                    </p>
                    <p>
                        <a-icon type="setting" />
                        {{ $t("message.howToEnableNotificationInstruction3") }}
                    </p>
                    <p>
                        <a-icon type="notification" />
                        {{ $t("message.howToEnableNotificationInstruction4") }}
                    </p>
                </div>
            </a-modal>
        </div>
    </transition>
</template>

<script>
import { mapActions, mapState } from "vuex";
import _ from "lodash";
import { WEB_PUSH_NOTIFICATION_SERVICE } from "../push-notification/subscribe";
import { enableDesktopNotification } from "../utils/desktopNotification";

export default {
    name: "NotificationPermissionAlert",

    data() {
        return {
            deniedMode: false,
            showNotificationEnableGuidModal: false,
        };
    },
    computed: {
        ...mapState({
            user: (state) => state.auth.user,
        }),
    },
    methods: {
        ...mapActions({
            updateUser: "user/updateUser",
            refreshAuthUser: "auth/refreshAuthUser",
        }),
        enableNotifications() {
            if (this.deniedMode) {
                this.showNotificationEnableGuidModal = true;
                return;
            }
            const user = _.cloneDeep(this.user);
            WEB_PUSH_NOTIFICATION_SERVICE.promptNotificationPermission();
            enableDesktopNotification()
                .then((x) => {
                    user.notificationSettings.forEach((not) => {
                        not.desktopNotification = true;
                    });
                    this.updateUser({ ...user }).then((x) => {
                        this.refreshAuthUser();
                    });
                    this.$emit("close");
                    // this.isNotifyShowing = false;
                    this.$message.success({
                        content: this.$t("message.pushNotificationEnabled"),
                        key: "notification",
                        duration: 3,
                    });
                })
                .catch((x) => {
                    console.error("Notification service unsuccessful", x);
                    if (x === "denied") {
                        this.$message.error({
                            content: this.$t("message.pushNotificationDenied"),
                            key: "notification",
                            duration: 3,
                        });
                        user.notificationSettings.forEach((x) => {
                            x.desktopNotification = false;
                        });
                        this.updateUser({ ...user }).then((x) => {
                            this.refreshAuthUser();
                        });
                        this.deniedMode = true;
                    }
                });
        },
        closeNotification() {
            sessionStorage.setItem("dismissed-notify-alert", "true");
            // this.isNotifyShowing = false;
            this.$emit("close");
        },
    },
    mounted() {
        if (Notification.permission === "denied") {
            this.deniedMode = true;
        }
        window.document.body.classList.add("notification-request-active");
    },
    beforeDestroy() {
        window.document.body.classList.remove("notification-request-active");
    },
};
</script>

<style lang="scss">
body.notification-request-active {
    .wrapper {
        .main-content {
            height: calc(100vh - 55px - 45px) !important;
        }
    }

    #chatWindow {
        .chatContainer {
            height: calc(100vh - 140px - 45px) !important;
        }
    }
}

.notification-request {
    position: static;
    top: 0;
    z-index: 9999;
    width: 100%;
    background-color: rgba(30, 30, 45, 0.95);
    color: #ffffff;
    font-family: "Poppins", "Helvetica Neue", Helvetica, Arial, sans-serif;
    box-sizing: border-box;
    display: flex;
    padding: 6px;
    justify-content: space-between;
    cursor: pointer;
    height: 45px;
    align-items: center;

    &-text {
        margin: 0;
        padding: 0;
    }

    &-button {
        text-decoration: underline;
        background: none;
        border: none;
        margin: 0;
        padding: 0;

        &:hover {
            color: #3ba9f3;
        }
    }

    &-close {
        &-button {
            background: none;
            border: none;
            margin: 0 12px;
            padding: 0;
        }
    }

    &-icon {
        &:hover {
            color: #3ba9f3 !important;
        }
    }

    &.denied {
        background-color: rgba(246, 78, 96, 0.94);
        color: #1e1e2d;
        cursor: pointer;
    }
}

.slide-fade-enter-active {
    transition: all 0.3s ease;
}

.slide-fade-leave-active {
    transition: all 0.6s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter,
.slide-fade-leave-to {
    transform: translateY(-50%);
    opacity: 0;
}
</style>
